import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { CarrouselTotal } from '../../Components/Public/Carrousel/CarrouselTotal.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockLegend } from '../../Components/Public/Blocks/BlockLegend.js';
import { BlockLogoCharacters } from '../../Components/Public/Logos/BlockLogoCharacters.js';
import { BlockLogoAttraction } from '../../Components/Public/Logos/BlockLogoAttraction.js';
import { BlockTitleDate1Link1 } from '../../Components/Public/Blocks/BlockTitleDate1Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';

export const Origin = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [origin, setOrigin] = useState([]);
    const [attractions, setAttractions] = useState([]);
    const [characters, setCharacters] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasOrigin = await fetch(`${backend}/origin?id=${id}`, GetHeaders(guest));
            const origin = await datasOrigin.json();
            setOrigin(origin);
            const datasAttractions = await fetch(`${backend}/attractions_by_origin?id=${id}`, GetHeaders(guest));
            const attractions = await datasAttractions.json();
            setAttractions(attractions);
            const datasCharacters = await fetch(`${backend}/characters_by_origin?id=${id}`, GetHeaders(guest));
            const characters = await datasCharacters.json();
            setCharacters(characters);
        };
        fetchData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const carrouselDatas = CarrouselDatas('origin', origin);
    const carrouselTotal = CarrouselTotal('origin', origin);
    const total = attractions.length + characters.length;
    const items = GetDescription('origin', { origin: origin, attractions: attractions, characters: characters });
    return (
        <div className="origin">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="origin" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="origin" />
            <section className="infos">
                <div className="list">
                    <BlockLegend parks={navParks} total={total} />
                    {attractions.map((item, i) => {
                        return (
                            <BlockLogoAttraction label="origin" item={item} key={`a-${i}`} />
                        )
                    })}
                    {characters.map((item, i) => {
                        return (
                            <BlockLogoCharacters label="origin" item={item} key={`c-${i}`} />
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link1 label="origin" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}